export interface OptionInterface {
  value :any;
  label :string;
  subLabel ?:any;
  checked ?:boolean;
  count ?:number;
}

export interface IIdName {
  id :string | number;
  name :string;
}

export interface IIdLabel {
  id :string | number;
  label :string;
}

export interface CheckedItemInterface {
  checked :boolean;
  value :string | number;
}

export interface IKeyValue {
  key :string | number;
  value :string | number;
}

export interface IValueLabel {
  value :string | number;
  label :string;
}

export interface IFieldLabel {
  field :string | number;
  label :string;
}

export interface IScannerResponse {
  id :number;
  orderNumber :number;
  type :string;
  warehouseGroupId :any;
  scannedValue :string;
}

export enum EScannerType {
  RFQ = 'RFQ',
  LOCATION = 'LOCATION',
  ORDER_NOT_IN_PICKING = 'ORDER_NOT_IN_PICKING',
  ORDER_SHIPPED = 'ORDER_SHIPPED',
  ORDER_PICKLIST_CREATED = 'ORDER_PICKLIST_CREATED',
  ORDER_PICKLIST_PICKED = 'ORDER_PICKLIST_PICKED',
  UNKNOWN = 'UNKNOWN',
}

// ENUMS
// https://www.youtube.com/watch?v=0fTdCSH_QEU&t=355s
const CommonStatus = {
  ACTIVE: 'Active',
};

export const SortDirections = {
  ASC: 'asc',
  DESC: 'desc',
};

export enum ArrowEvent {
  ARROW_UP = 'ArrowUp',
  ARROW_DOWN = 'ArrowDown',
  ARROW_RIGHT = 'ArrowRight',
  ARROW_LEFT = 'ArrowLeft',
}

export type CommonStatusEnum = (typeof CommonStatus)[keyof typeof CommonStatus];
export type SortDirectionsEnum =
  (typeof SortDirections)[keyof typeof SortDirections];

export interface IDimension {
  units :string;
  length :number;
  width :number;
  height :number;
}

export interface IWeight {
  units :string;
  value :number;
}

export interface IFieldConfig {
  path: string;
  fallback?: string;
  type?: 'date' | string;
  transform?: (value: any, item?: any) => string;
}
